import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import {
  selectAllKnockStatuses,
  selectKnockStatusById,
} from '@user/store/knockStatus/slice'
import { KnockStatusInput } from '@user/store/knockStatus/typings'
import { RootState } from '@user/store/reducers/createReducers'

export const useAddKnockStatusData = (editId?: string) => {
  const allStatuses = useSelector(selectAllKnockStatuses)
  const editStatus = useSelector((state: RootState) =>
    editId ? selectKnockStatusById(state, editId) : undefined,
  )

  const initialValues: KnockStatusInput = useMemo(
    () => ({
      id: editStatus?.id,
      name: editStatus?.name || '',
      color: editStatus?.color || '',
      icon: (editStatus?.icon ?? null) as KnockStatusInput['icon'],
    }),
    [editStatus],
  )

  const existingNames = useMemo(
    () =>
      allStatuses
        .filter((s) => s.id !== editId)
        .map((s) => s.name.toLowerCase()),
    [allStatuses, editId],
  )

  return {
    initialValues,
    existingNames,
    isEditMode: !!editId,
  }
}
